import { INotification, NotificationType } from '@common/stores';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';

interface IProps {
    onClose: () => void,
    notification: INotification
}

const DefineSymbol = (notificationType: NotificationType) => {

    let symbol = ""

    switch (notificationType) {
        case NotificationType.SUCCESS:
            symbol = "fa-check"
            break;
        case NotificationType.ERROR:
            symbol = "fa-exclamation-triangle"
            break;
        case NotificationType.INFO:
            symbol = "fa-info-circle"
            break;

        default:
            break;
    }

    return symbol
}

export const NotificationToast = ({ notification: { message, type, sticky, body }, onClose }: IProps) => {
    const [show, setShow] = useState(true);
    const close = () => {
        setShow(false);
        onClose();
    }
    const symbol = DefineSymbol(type)
    const duration = type === NotificationType.SUCCESS ? 2500 : 10000;
    const bg = type.toLowerCase();
    return (
        <Toast show={show} onClose={close} autohide={!sticky} animation delay={duration} bg={bg}>
            <Toast.Header>
                <strong className="me-auto">
                    <i className={classNames("fa", symbol)}></i>
                    <span style={{ marginLeft: "0.5rem", whiteSpace: "pre-line" }}>{
                        (typeof message === 'object') ? JSON.stringify(message) : message
                    }</span>
                </strong>
            </Toast.Header>
            {body && <Toast.Body>{body}</Toast.Body>}
         </Toast>
    )
};
